/*
 * postaljs.js — postcode-checker banner
 * --------------------------------------
 * Rewritten to use the shared WFYDelivery lookup (assets/wfy-delivery-lookup.js)
 * instead of 6000+ lines of inline data. Flow inside the banner drawer:
 *   enter postcode → if it splits across zones, pick a suburb → see delivery days.
 * jQuery is available globally (loaded in theme.liquid before this file).
 */
(function () {
  'use strict';

  var URL = window.WFY_DELIVERY_URL;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function windowsHtml(title, windows, note) {
    var html = '<div style="text-align:center" class="delivery-zone"><h4>' + esc(title) + '</h4>';
    (windows || []).forEach(function (w) { if (w) html += '<div>' + esc(w) + '</div>'; });
    if (note) html += '<br><div><p>Please note – we deliver <strong>only</strong> to suburb names listed above</p></div>';
    html += '</div>';
    return html;
  }

  function render(html) {
    jQuery('.delivery-zone-wrapper .results').html(html);
  }

  function notServed(pc) {
    render('<div style="margin: 1em;"><h5>Sorry, we don’t deliver to "' + esc(pc) + '".</h5></div>');
  }

  function check(pc) {
    var D = window.WFYDelivery;
    if (!D) return;
    var suburbs = D.getSuburbs(pc);
    if (!suburbs.length) { notServed(pc); return; }

    // Distinct peLocations across this postcode's suburbs → split or not?
    var byPe = {};
    suburbs.forEach(function (s) {
      var r = D.resolve(pc, s);
      if (r && r.peLocation) byPe[r.peLocation] = 1;
    });

    if (Object.keys(byPe).length <= 1) {
      // Non-split: one set of windows covers the whole postcode.
      var info = D.resolve(pc, suburbs[0]);
      render(windowsHtml(suburbs.join(', '), info ? info.windows : [], true));
      return;
    }

    // Split: show a suburb dropdown; selection renders that suburb's windows.
    var opts = '<option value="">Select your suburb</option>';
    suburbs.forEach(function (s) { opts += '<option value="' + esc(s) + '">' + esc(s) + '</option>'; });
    render(
      '<div class="delivery-zone" style="text-align:center">' +
        '<p><strong>Select your suburb to see delivery days:</strong></p>' +
        '<select class="wfy-banner-suburb" data-pc="' + esc(pc) + '" ' +
        'style="max-width:260px;margin:0 auto 10px;display:block;padding:6px;">' + opts + '</select>' +
        '<div class="wfy-banner-windows"></div>' +
      '</div>'
    );
  }

  // ---- drawer open/close (unchanged behaviour) ----
  jQuery(document).on('click', '.delivery-zone-checker-click', function (e) {
    e.preventDefault();
    jQuery('.delivery-zone-checker').slideToggle();
  });
  jQuery(document).on('click', '.closeChecker', function (e) {
    e.preventDefault();
    jQuery('.delivery-zone-checker').slideToggle();
  });

  // ---- postcode entry (live, debounced; requires 4 digits) ----
  var timer = 0;
  jQuery(document).on('keyup change', 'input[name="postal-input-gd"]', function () {
    var pc = String(this.value || '').trim();
    clearTimeout(timer);
    if (pc.length < 4) return;
    if (!window.WFYDelivery) return;
    timer = setTimeout(function () {
      window.WFYDelivery.load(URL)
        .then(function () { check(pc); })
        .catch(function () { render('<div style="margin: 1em;">Sorry, we couldn’t check that right now.</div>'); });
    }, 150);
  });

  // ---- suburb chosen from the injected dropdown ----
  // Delegated on document because `.results` is rewritten on each keystroke.
  jQuery(document).on('change', '.wfy-banner-suburb', function () {
    var pc = String(jQuery(this).data('pc'));
    var suburb = this.value;
    var box = jQuery(this).closest('.delivery-zone').find('.wfy-banner-windows');
    if (!suburb || !window.WFYDelivery) { box.html(''); return; }
    var info = window.WFYDelivery.resolve(pc, suburb);
    box.html(info ? windowsHtml(suburb, info.windows) : '');
  });

  // Warm the cache (banner is above the fold).
  if (window.WFYDelivery && URL) window.WFYDelivery.load(URL).catch(function () {});
})();
